exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pie {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: white; }\n\n.mask {\n  content: '';\n  display: block;\n  margin-left: 50%;\n  height: 100%;\n  border-radius: 0 100% 100% 0 / 50%;\n  background-color: inherit;\n  transform-origin: left; }\n\n.pie-data {\n  text-align: center;\n  background-color: #fff;\n  height: 60%;\n  width: 60%;\n  border-radius: 50%; }\n\n.centralise-element {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: inherit;\n  line-height: 10px; }\n\n.small {\n  height: 60%;\n  width: 60%; }\n\n.large {\n  height: 80%;\n  width: 80%; }\n\n.bold-text {\n  font-size: 10px;\n  font-weight: 700; }\n\n.normal-text {\n  display: inline-block; }\n\n.pie-chart-title {\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  margin-top: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/pie-chart/pie-chart.component.scss
// module id = ../../../../../src/app/core/components/pie-chart/pie-chart.component.scss
// module chunks = main